module.exports = __webpack_public_path__ + "static/media/experiences-modal.bcc8d9fe.png";